import { getAuthService } from "src/backend/msal/auth-manager";
export const getAuthenticationHeaderAsync = async () => {
    const authService = getAuthService();
    const tokenResult = await authService.getAccessToken();
    if (tokenResult?.accessToken && tokenResult?.tokenType) {
        return { Authorization: `${tokenResult.tokenType} ${tokenResult.accessToken}` };
    }
    return undefined;
};
